import { type PhoneNumberConfiguration } from 'primary-schema';

import { type Common } from '../common.js';
import { type PaginatedQueryOptions } from '../models/pagination/PaginatedQueryOptions.type.js';
import { type PaginationResponse } from '../models/pagination/PaginationResponse.type.js';
import {
  type CreateValues,
  type FindAllOptions,
  type PhoneNumberConfigurationRow,
  type UpdatePracticeRoutingValues,
  type UpdateValues,
} from '../models/phoneNumber/phoneNumberConfiguration.js';

export class API {
  common: Common;
  baseEndpoint: string;

  constructor(common: Common) {
    this.common = common;
    this.baseEndpoint = '/assistant/phone-number-configurations';
  }

  async findAllPaginated(
    options: PaginatedQueryOptions<FindAllOptions>
  ): Promise<PaginationResponse<PhoneNumberConfiguration>> {
    const url = this.common.constructPath(this.baseEndpoint, options);
    return await this.common.getJSON(url);
  }

  async findAll(options: FindAllOptions): Promise<PhoneNumberConfiguration[]> {
    const url = this.common.constructPath(this.baseEndpoint, options);
    return await this.common.getJSON(url);
  }

  async findOneById(id: string): Promise<PhoneNumberConfiguration> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${id}`);
    return await this.common.getJSON(url);
  }

  async updateDetails(
    id: string,
    values: Pick<UpdateValues, 'displayName'>
  ): Promise<PhoneNumberConfigurationRow> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${id}/details`);
    return await this.common.patchJSON(url, values);
  }

  async update(id: string, values: UpdateValues): Promise<PhoneNumberConfigurationRow> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${id}`);
    return await this.common.patchJSON(url, values);
  }

  async updatePracticeRouting(
    id: string,
    values: UpdatePracticeRoutingValues
  ): Promise<PhoneNumberConfigurationRow> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${id}/practice-routing`);
    return await this.common.patchJSON(url, values);
  }

  async create(values: CreateValues): Promise<PhoneNumberConfigurationRow> {
    const url = this.common.constructPath(this.baseEndpoint);
    return await this.common.postJSON(url, values);
  }

  async remove(id: string): Promise<PhoneNumberConfigurationRow> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${id}`);
    return await this.common.deleteJSON(url);
  }

  async restore(id: string): Promise<PhoneNumberConfigurationRow> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${id}/restore`);
    return await this.common.postJSON(url, {});
  }
}
